var Inquire = (function() {
  var __private = {
    url: "/ajax/item/",
    disClass : "disabled",
    cookieUser: "",
    cookieEmail: "",

    listeners() {
      if (document.querySelector('.inquiryContainer')) {
        document.querySelectorAll('.inquiryContainer a').forEach(function (el) {
          el.addEventListener('click', function (event) {
            event = event || window.event;
            var target = event.target;
            var link = target.getAttribute("link");
            var item_id = target.getAttribute("id");

            __private.reply(item_id, link, target);
          })
        });
      }
    },

    boot() {
      Intercom('shutdown');

      Intercom('boot', {  
        app_id: 'vg8h178b',
        id: __private.getCookie("lc-intercom"),
        user_id: __private.getCookie("lc-intercom"),
        email: __private.getCookie("lc-intercom-email")
      });
    },

    contact() {
      if (__private.getCookie("lc-intercom")) {
        __private.boot();
      } else {
        var xhr = new XMLHttpRequest();

        xhr.open("POST", __private.url + "contact", true);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send(__private.getFormValues('', ''));
        xhr.onreadystatechange = function() {

          if (this.readyState === 4) {
            let response = JSON.parse(this.responseText);

            if (this.status === 200) {
              if(response) {
                document.cookie = `lc-intercom=${ response.id }`;
                document.cookie = `lc-intercom-email=${ response.email }`;
              }

              __private.boot();
            }
          }
        };
        xhr.onerror = function() {
          console.error("Inquire error: " + this.status);
        }
      }
    },

    converse(item_id, link, target) {
      var xhr = new XMLHttpRequest();

      if(item_id) {
        xhr.open("POST", __private.url + "converse/" + item_id, true);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send(__private.getFormValues(item_id, link));
        xhr.onreadystatechange = function() {
          if (this.readyState === 4) {
            let response = JSON.parse(this.responseText);

            if (this.status === 200) {
              if(response && !response.errors)
                Intercom('update', {
                  id: __private.getCookie("lc-intercom"),
                  user_id: __private.getCookie("lc-intercom"),
                  email: __private.getCookie("lc-intercom-email")
                });

                Intercom('show');

                Intercom('onShow', function() {
                  Intercom('showConversation', response.conversation_id);
                });
            }
          }
        };
        xhr.onerror = function() {
          console.error("Inquire error: " + this.status);
        }
      }
    },

    // reply(item_id, link, target) {
    //   var xhr = new XMLHttpRequest();
      
    //   if(item_id) {
    //     xhr.open("POST", __private.url + "inquire/" + item_id, true);
    //     xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    //     xhr.send(__private.getFormValues(item_id, link));
    //     xhr.onreadystatechange = function() {
    //       if (this.readyState === 4) {
    //         let response = JSON.parse(this.responseText);

    //         if (this.status === 200) {
    //           if (response && !response.errors) {


    //             // Boot or update Intercom with the current user
    //             Intercom('update', {
    //               user_id: __private.getCookie("lc-intercom"),
    //               email: __private.getCookie("lc-intercom-email")
    //             });

    //             console.log(`conversation: `, response);
    //             setTimeout(() => Intercom('showConversation', response.id), 500);



    //           } else {
    //             __private.converse(item_id, link, target);
    //             console.log(`no conversation: `, response);
    //             Intercom('showNewMessage', message);
    //           }
    //         }
    //       }
    //     };
    //     xhr.onerror = function() {
    //       console.error("Inquire error: " + this.status);
    //     }
    //   }
    // },

    reply(item_id, link, target) {
      const message = `I would like to request information about this car listing ${target.title} ${target.getAttribute("link")}`;
      const xhr = new XMLHttpRequest();
    
      xhr.open("POST", __private.url + "inquire/" + item_id, true);
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr.send(__private.getFormValues(item_id, link));
    
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          const response = JSON.parse(xhr.responseText || '{}');
    
          Intercom('update', {
            user_id: __private.getCookie("lc-intercom"),
            email: __private.getCookie("lc-intercom-email")
          });
    
          if (xhr.status === 200 && response && !response.errors && response.id) {
            // Try to show the conversation
            setTimeout(() => {
              Intercom('showConversation', response.id);
    
              // fallback if not visible
              // setTimeout(() => {
              //   Intercom('showMessages');
              // }, 1500);
            }, 500);
          } else {
            // fallback if no conversation created – open new message box
            console.log(`no fallback: `, response);
            Intercom('showNewMessage', message);
           
          }
        }
      };
    },    

    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return "";
    },

    btnDisabled(flag, btn) {
      if(flag) btn.classList.add(this.disClass);
      else btn.classList.remove(this.disClass);
    },

    getFormValues(item_id, link) {
      var formData = new FormData();

      if (item_id)
        formData.append('id', item_id);

      if (link)
        formData.append('link', link);

      var token = document.querySelector('[name="_token"]');

      formData.append('_token', token.value);

      if (__private.getCookie("lc-intercom"))
        formData.append('user_id', __private.getCookie("lc-intercom"));

      return formData;
    }
  };

  return {
    init() {
      __private.listeners();
      __private.contact();
      __private.boot();
    }
  };
})();


(function() {
  document.addEventListener("DOMContentLoaded", function() {
    Inquire.init();
  });
})();